module.exports = __webpack_public_path__ + "static/media/wuyi1Bg.3fc9c56f.jpg";